import React from 'react'
import Header from './Header'
import Navigation from './Navigation'
import Ribbon from './Ribbon'
import Footer from './Footer'
import Shortcut from './Shortcut'
import PromoBanner from '../common/PromoBanner'
import FullscreenLoader from '../common/FullscreenLoader'

import '../../../components/layout/less/layout.less'
import adLeaderImage from '../../../assets/images/login_banner.jpg'
import styles from './Layout.module.css'

export default ({ appName, children }) =>
  <div className={styles.pageWrapper}>
    <Header appName={appName} />
    <Navigation />
    <div id="main" role="main" className={styles.mainContent}>
      <Ribbon />
      <PromoBanner
        className={styles.ad}
        imgSrc={adLeaderImage}
        // url="https://mydiamond.app.link/login_leader"
      />
      {children}
    </div>
    <Footer />
    <Shortcut />
    <FullscreenLoader />
  </div>
